/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Lazy load heavy services after app initialization
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    // Load non-critical services after app is ready
    if (typeof window !== 'undefined') {
      // Load non-critical CSS first
      import('./app/core/css-loader.service').then(({ CssLoaderService }) => {
        const cssService = new CssLoaderService();
        cssService.loadNonCriticalStyles();
      });

      // Load heavy services after a short delay
      setTimeout(() => {
        import('./app/core/lazy-loading.service').then(({ LazyLoadingService }) => {
          const lazyService = new LazyLoadingService();
          lazyService.loadFirebase();
          lazyService.loadGTM();
        });
      }, 500);
    }
  })
  .catch((err) => console.error(err));
